import { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AuthPageShell from "Pages/Auth/AuthPageShell";
import AuthStatusCard from "Pages/Auth/AuthStatusCard";
import { setWebInfo } from "Redux/Actions/Index";
import ConsentService from "Services/Consent/ConsentService";
import Commonservice from "Services/CommonService";
import { getTicketFromUrl } from "Utils/Common";
import { setFaviconAndTitle } from "Utils/Common/CommonMethods";

type PageState = "loading" | "success" | "invalid" | "error";

const ConsentUpdate = () => {
  const dispatch = useDispatch();
  const ticket = getTicketFromUrl();

  const [pageState, setPageState] = useState<PageState>(
    ticket ? "loading" : "invalid"
  );
  const [logoUrl, setLogoUrl] = useState("");

  useLayoutEffect(() => {
    Commonservice.getLoginPageLogo()
      .then((res: any) => {
        const logo = res.data?.logo || res.data;
        setLogoUrl(typeof logo === "string" ? logo : "");
        dispatch(
          setWebInfo({
            smartLogoUrl: res.data?.smartLogo,
            title: res.data?.labName,
          })
        );
        setFaviconAndTitle(res.data?.smartLogo, res.data?.labName);
      })
      .catch(() => {});
  }, [dispatch]);

  useLayoutEffect(() => {
    if (!ticket) {
      setPageState("invalid");
      return;
    }

    ConsentService.saveConsent(ticket)
      .then((response) => {
        const status = response.data?.StatusCode;
        if (status === 200) {
          setPageState("success");
        } else {
          setPageState("error");
        }
      })
      .catch(() => {
        setPageState("error");
      });
  }, [ticket]);

  if (pageState === "loading") {
    return (
      <AuthPageShell>
        <div className="w-lg-500px bg-body rounded shadow-sm p-10 mx-auto text-center">
          <div className="spinner-border text-primary mb-4" role="status">
            <span className="visually-hidden">Loading…</span>
          </div>
          <p className="text-muted">Updating your preference, please wait…</p>
        </div>
      </AuthPageShell>
    );
  }

  if (pageState === "invalid") {
    return (
      <AuthPageShell>
        <AuthStatusCard
          title="Invalid Link"
          description="This consent link is invalid. Please contact the laboratory for assistance."
          icon="bi-exclamation-triangle"
          variant="danger"
        />
      </AuthPageShell>
    );
  }

  if (pageState === "error") {
    return (
      <AuthPageShell>
        <AuthStatusCard
          title="Something Went Wrong"
          description="We were unable to update your communication preference. Please try again later or contact the laboratory for assistance."
          icon="bi-x-circle"
          variant="danger"
        />
      </AuthPageShell>
    );
  }

  return (
    <AuthPageShell>
      <div className="w-lg-550px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto text-center">
        {logoUrl && <img alt="Logo" src={logoUrl} className="h-45px mb-8" />}
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light-success mb-6"
          style={{ width: 72, height: 72 }}
        >
          <i
            className="bi bi-check-circle text-success"
            style={{ fontSize: "2.25rem" }}
            aria-hidden
          />
        </div>
        <h1 className="fw-bold fs-2 mb-3">Preference Updated</h1>
        <p className="text-muted fs-6 mb-0 px-4">
          Your communication preference has been updated successfully.
        </p>
      </div>
    </AuthPageShell>
  );
};

export default ConsentUpdate;
